import {
  Authenticator,
  Heading,
  Text,
  Image,
  useTheme,
  View,
} from "@aws-amplify/ui-react";
import { Amplify, Auth } from "aws-amplify";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import awsconfig from "./aws-exports";
//redux
import { Provider } from "react-redux";
import store from "./Store/Store";
//Components
import "./App.css";
import Footer from "./components/footer";
import Header from "./components/header";
import Home from "./components/home";
import PatientBanner from "./components/PatientBanner";
import PastAppointments from "./components/PastAppointments/PastAppointments";
import RegisterPatientForm from "./components/startForm";
import Maintenance from "./components/Testing/Maintenance"; // eslint-disable-line no-unused-vars
import PatientBooking from "./components/Booking/Booking";
import CreatePatientForm from "./components/createPatientForm";
import EditPatient from "./components/editPatient";
import ChangePassword from "./components/changePassword";

// Images
import logo from "./images/tmiic.png";
import background from "./images/signInBackground.png";

//MUI
import { Box } from "@mui/material";

Amplify.configure(awsconfig);

const components = {
  Header() {
    const { tokens } = useTheme();
    return (
      <View textAlign="center" padding={tokens.space.large}>
        <Image alt="TMIIC logo" src={logo} height="4rem" />
      </View>
    );
  },
  Footer() {
    const { tokens } = useTheme();
    return (
      <View
        padding={tokens.space.small}
        style={{ fontSize: 15, textAlign: "center" }}
      >
        <address>
          For technical support, email us at{" "}
          <a href="mailto:bookings.techsupport@qdoc.ca">
            bookings.techsupport@qdoc.ca
          </a>
        </address>

        <Text color={tokens.colors.neutral[80]}>
          &copy; {new Date().getFullYear()} The Minor Illness & Injury Clinic
        </Text>
      </View>
    );
  },
  VerifyUser: {
    Header() {
      return (
        <Heading level={3}>
          Please select the correct email address below to verify your account
        </Heading>
      );
    },
  },
  ConfirmVerifyUser: {
    Header() {
      return <Heading level={3}>Enter code sent to your email address</Heading>;
    },
    Footer() {
      return (
        <Text>
          Please check your junk/spam folder if you have not received a code.
        </Text>
      );
    },
  },
  ConfirmSignUp: {
    Header() {
      return <Heading level={3}>We Emailed You</Heading>;
    },
    Footer() {
      return (
        <Text>
          Please check your junk/spam folder if you have not received a code.
        </Text>
      );
    },
  },
};

const validateUsername = (username) => {
  if (/\s/.test(username)) {
    throw new Error(
      "Username cannot contain spaces. Please choose a username without spaces."
    );
  }
};

function App() {
  return (
    <div
      style={{
        backgroundImage: `url(${background})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Authenticator
        components={components}
        initialState="signIn"
        services={{
          async handleSignUp(input) {
            const { username, password, attributes } = input;

            validateUsername(username);

            if (attributes?.email) {
              attributes.email = attributes.email.toLowerCase();
            }

            return Auth.signUp({
              username: username,
              password,
              attributes,
              autoSignIn: { enabled: true },
            });
          },
          async handleSignIn(input) {
            const { username, password } = input;
            validateUsername(username);

            return Auth.signIn(username, password);
          },
        }}
        formFields={{
          signUp: {
            username: { placeholder: "Choose a username (no spaces)" },
          },
          signIn: {
            username: { placeholder: "Enter your username (no spaces)" },
          },
        }}
      >
        <div className="App">
          <Provider store={store}>
            <Box
              sx={{
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <BrowserRouter>
                <Box sx={{ flexShrink: 0 }}>
                  <Header />
                  <PatientBanner />
                </Box>
                <Box sx={{ flexGrow: 1 }}>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route
                      path="PastAppointments"
                      element={<PastAppointments />}
                    />
                    <Route path="startForm" element={<RegisterPatientForm />} />
                    <Route
                      path="createPatientForm"
                      element={<CreatePatientForm />}
                    />
                    <Route path="patientBooking" element={<PatientBooking />} />
                    <Route path="editPatient" element={<EditPatient />} />
                    <Route path="changePassword" element={<ChangePassword />} />
                    <Route
                      path="*"
                      element={<p>There's nothing here: 404!</p>}
                    />
                  </Routes>
                </Box>
              </BrowserRouter>
              <Footer />
            </Box>
          </Provider>
        </div>
      </Authenticator>
    </div>
  );
}
export default App;
